export enum STORAGE_KEY {
  MARKETING = 'marketing',
  TUTORIAL = 'detailTutorialComplete',
  SUBSCRIPTION = 'subscriptionComplete',
  RECENT_KEYWORD = 'recentKeyword',
  EXTENSION_GUIDE = 'extensionGuideClosed',
  ASK_AI_GUEST_QUESTION_COUNT = 'anonymous_news_user_question_count',
}
